<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@for (arc of data; track trackBy($index, arc)) {
  <svg:g>
    @if (labelVisible(arc)) {
      <g ngx-charts-pie-label
        [data]="arc"
        [radius]="outerRadius"
        [color]="color(arc)"
        [label]="labelText(arc)"
        [labelTrim]="trimLabels"
        [labelTrimSize]="maxLabelLength"
        [max]="max"
        [value]="arc.value"
        [explodeSlices]="explodeSlices"
      [animations]="animations"></g>
    }
    <g ngx-charts-pie-arc
      [startAngle]="arc.startAngle"
      [endAngle]="arc.endAngle"
      [innerRadius]="innerRadius"
      [outerRadius]="outerRadius"
      [fill]="color(arc)"
      [value]="arc.data.value"
      [gradient]="gradient"
      [data]="arc.data"
      [max]="max"
      [explodeSlices]="explodeSlices"
      [isActive]="isActive(arc.data)"
      [animate]="animations"
      (select)="onClick($event)"
      (activate)="activate.emit($event)"
      (deactivate)="deactivate.emit($event)"
      (dblclick)="dblclick.emit($event)"
      ngx-tooltip
      [tooltipDisabled]="tooltipDisabled"
      [tooltipPlacement]="'top'"
      [tooltipType]="'tooltip'"
      [tooltipTitle]="getTooltipTitle(arc)"
      [tooltipTemplate]="tooltipTemplate"
    [tooltipContext]="arc.data"></g>
    </svg:g>
  }
